/* eslint-disable camelcase */
export const enUS_analyticTitle = {
  'analytic.name': 'Analytics',
  'analytic.notification.processing.report': 'The report is being processed. When completed, the file will be sent to your email {email}.',
  'analytic.see.chat': 'See chat',
  'analytic.btn.download.chat': 'Chat Report',
  'analytic.btn.summary.download.chat': 'Summary',
  'analytic.tooltip.download.chat': 'Downloads the filtered data and/or all visible values in the table',
  'analytic.survey.binary': 'Binary',
  'analytic.survey.stars': 'Stars',
  'analytic.survey.1': '1',
  'analytic.survey.2': '2',
  'analytic.survey.3': '3',
  'analytic.survey.4': '4',
  'analytic.survey.5': '5',
  'analytic.survey.nps': 'NPS',
  'analytic.survey.positive': 'Positive',
  'analytic.survey.positives': 'Positive',
  'analytic.survey.neutral': 'Neutral',
  'analytic.survey.negative': 'Negative',
  'analytic.survey.negatives': 'Negative',
  'analytic.survey.promoters': 'Promoters',
  'analytic.survey.detractors': 'Detractors',
  'analytic.survey.csat': 'CSAT',
  'analytic.survey.none': 'No answer',
  'analytic.feedback.positive': 'Positive feedback',
  'analytic.feedback.negative': 'Negative feedback',
  'analytic.transferred.by.evasives': 'Transferred by evasives',
  'analytic.transferred.by.answer': 'Transferred by answer',
  'analytic.other': 'Other',
  'analytic.transferred.by.negative.feedback': 'Transferred by negative feedback',
  'analytic.transferred.by.same.answer': 'Transferred by same answer',
  'analytic.transferred.by.direct.derivation': 'Transferred by direct transfer',
  'analytic.transferred.by.answer.tool': 'Transferred by answer tool',
  'analytic.retained.by.agentbot': 'Retained by AgentBot',
};

